export const QUEST_RELIC_CAMERA_STORAGE_KEY = "vocabularium_quest_relic_camera";

export function readAllRelicCameraPresets() {
  try {
    const raw = localStorage.getItem(QUEST_RELIC_CAMERA_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function readRelicCameraPreset(relicId) {
  if (!relicId) return null;
  const presets = readAllRelicCameraPresets();
  const entry = presets[relicId];
  if (!entry || typeof entry !== "object") return null;

  const fitOffset = Number(entry.fitOffset);
  if (!Number.isFinite(fitOffset) || fitOffset <= 0) return null;

  return { fitOffset };
}

export function writeRelicCameraPreset(relicId, preset) {
  if (!relicId || !preset) return;

  const fitOffset = Number(preset.fitOffset);
  if (!Number.isFinite(fitOffset) || fitOffset <= 0) return;

  const presets = readAllRelicCameraPresets();
  presets[relicId] = {
    fitOffset: +fitOffset.toFixed(4),
    updatedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(QUEST_RELIC_CAMERA_STORAGE_KEY, JSON.stringify(presets));
  } catch {
    // ignore quota / privacy mode errors
  }
}

export function formatRelicCameraPresetsForConstants(presets) {
  return Object.entries(presets)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([id, entry]) => `  ${JSON.stringify(id)}: ${entry.fitOffset},`)
    .join("\n");
}

export function logRelicCameraPresets(relicId, fitOffset) {
  const presets = readAllRelicCameraPresets();

  console.groupCollapsed(`[QuestRelicCamera] ${relicId} — fitOffset ${fitOffset.toFixed(3)}`);
  console.log("fitOffset", +fitOffset.toFixed(4));
  console.log("localStorage", presets);
  console.log(
    "À copier dans questRelics.js (cameraFitOffset par relique) :\n" +
      formatRelicCameraPresetsForConstants(presets)
  );
  console.groupEnd();
}
